// Package IDs are the existing Firestore calendar values. Never rename these IDs.
// Defaults apply only when creating a booking or explicitly changing its package.
export const PACKAGE_PRICING_VERSION = 2;
export const ADDITIONAL_CHILD_PRICE = 15;
export const ADDITIONAL_ADULT_PRICE = 10;
export const ADDITIONAL_PIZZA_PRICE = 25;

export const PARTY_PACKAGES = Object.freeze([
  { id: "Package 1", name: "Prince/Princess Celebration", price: 1800, durationHours: 2, includedKids: 25, includedAdults: 35, includedPizzas: 5, includedJuiceBoxes: 25 },
  { id: "Package 2", name: "Fairy Tale Celebration", price: 2300, durationHours: 2.5, includedKids: 35, includedAdults: 45, includedPizzas: 6, includedJuiceBoxes: 35 },
  { id: "Package 3", name: "Luminous Castle Celebration", price: 3000, durationHours: 3, includedKids: 45, includedAdults: 55, includedPizzas: 8, includedJuiceBoxes: 45 },
  { id: "Package 4", name: "Majestic Royal Celebration", price: 4000, durationHours: 4, includedKids: 50, includedAdults: 65, includedPizzas: 9, includedJuiceBoxes: "unlimited" },
  // Weekday durations and guest allowances were not defined in this codebase.
  { id: "Non-Private Party 1", name: "Non Private Party 1", price: 300, includedPizzas: 3, privateParty: false, additionalChildPrice: 20, additionalAdultPrice: 15 },
  { id: "Non-Private Party 2", name: "Non Private Party 2", price: 700, includedPizzas: 4, privateParty: false, additionalChildPrice: 20, additionalAdultPrice: 15 },
].map((pkg) => Object.freeze({
  privateParty: true,
  additionalChildPrice: ADDITIONAL_CHILD_PRICE,
  additionalAdultPrice: ADDITIONAL_ADULT_PRICE,
  ...pkg,
})));

export const CALENDAR_PACKAGE_OPTIONS = Object.freeze([
  ...PARTY_PACKAGES.map((pkg) => pkg.id),
  "Commercial Use",
]);

export const findPartyPackage = (value) =>
  PARTY_PACKAGES.find((pkg) => pkg.id === value || pkg.name === value) || null;

export const describePackage = (pkg) => {
  if (!pkg) return "";
  return [
    pkg.durationHours != null && `${pkg.durationHours} hours`,
    pkg.includedKids != null && `${pkg.includedKids} kids`,
    pkg.includedAdults != null && `${pkg.includedAdults} adults`,
    pkg.includedPizzas != null && `${pkg.includedPizzas} large one-topping pizzas`,
    pkg.includedJuiceBoxes != null && (pkg.includedJuiceBoxes === "unlimited"
      ? "Unlimited juice boxes" : `${pkg.includedJuiceBoxes} juice boxes`),
  ].filter(Boolean).join("; ");
};
